import type { CreateOffer } from '@ooh/contracts';

/** The subset of `/offers/new`'s search params `buildDefaultValuesFromSearch` reads. */
export interface CreateOfferHandoffSearch {
  clientId?: number;
  salespersonId?: number;
  defaultDateFrom?: Date;
  defaultDateTo?: Date;
}

/**
 * Builds `useForm`'s one-time `defaultValues` from the "Otwórz pełny
 * formularz" hand-off search params (CU-86cb8grgn) — media unit selection,
 * term, and creating-mode form data carried through the quick-add picker's
 * escape hatch via `/offers/new` search params instead of being lost.
 * Extracted out of `create-offer-page.tsx` to keep `CreateOfferFormPage`'s
 * own cyclomatic complexity under the lint threshold and the file under the
 * max-lines limit.
 */
export function buildDefaultValuesFromSearch(
  search: CreateOfferHandoffSearch,
): Partial<CreateOffer> {
  return {
    ...(search.clientId != null ? { clientId: search.clientId } : {}),
    ...(search.salespersonId != null ? { salespersonId: search.salespersonId } : {}),
    ...(search.defaultDateFrom ? { defaultDateFrom: search.defaultDateFrom } : {}),
    ...(search.defaultDateTo ? { defaultDateTo: search.defaultDateTo } : {}),
  };
}
